<template>
  <div class="est-room__stage est-room__stage--preview">
    <!-- Hazırlık ekranındaki önizleme kendi görüntündür: aynalanır ve kırpılarak
         sığdırılır (`cover`) — 4:3 kamerada iki yanda kalan siyah bantlar sahneyi
         boş gösteriyordu. Karşı tarafın görüntüsü ise asla kırpılmaz.
         `playsinline` olmadan iOS Safari videoyu zorla tam ekrana alır ve danışan
         "Katıl" düğmesine ulaşamaz. -->
    <video v-show="showPreview" ref="landingPlayer" id="landingPlayer"
           class="est-room__video est-room__video--mirrored est-room__video--cover" muted autoplay playsinline></video>

    <!-- Kamera bilerek kapalıysa sahnede kendi baş harfin durur; izin/cihaz
         sorununda ise durum ikonu. -->
    <div v-if="!showPreview" class="est-room__placeholder">
      <span v-if="selfInitials" class="est-room__avatar est-room__avatar--stage" aria-hidden="true">{{ selfInitials }}</span>
      <span v-else class="est-room__placeholder-icon" aria-hidden="true">
        <font-awesome-icon :icon="mediaState.icon" />
      </span>
      <p class="est-room__placeholder-title">{{ $t(mediaState.title) }}</p>
    </div>

    <meeting-controls-component :camera-on="isCameraOpen"
                                :mic-on="isMicrophoneOpen"
                                :disabled="connections.LocalCamera !== 1"
                                @toggle-camera="$emit('toggle-camera')"
                                @toggle-mic="$emit('toggle-mic')" />
  </div>
</template>

<script>
  import MeetingControlsComponent from './MeetingControlsComponent.vue'
  import { nameInitials } from '../../../helpers/nameInitials'

  // Hazırlık hâlindeki sahne: yalnız yerel önizleme ve kamera/mikrofon şeridi.
  // Görüşme sahnesinden (`MeetingStageComponent`) ayrıdır çünkü uzak oynatıcı
  // id sözleşmesi ve tam ekran davranışı burada gereksizdir.
  export default {
    name: 'MeetingPreviewComponent',
    components: { MeetingControlsComponent },
    props: {
      connections: {
        type: Object,
        required: true
      },
      mediaState: {
        type: Object,
        required: true
      },
      isCameraOpen: Boolean,
      isMicrophoneOpen: Boolean,
      selfName: {
        type: String,
        default: ''
      }
    },
    computed: {
      selfInitials() {
        return this.connections.LocalCamera === 1 && !this.isCameraOpen ? nameInitials(this.selfName) : '';
      },
      localStream() {
        return this.$store.getters['Meeting/meetingStream'];
      },
      isLocalStreamStarted() {
        return this.localStream != null;
      },
      showPreview() {
        return this.connections.LocalCamera === 1 && this.isCameraOpen;
      }
    },
    methods: {
      initPlayer() {
        const vid = this.$refs.landingPlayer;
        if (!vid || !this.isLocalStreamStarted) return;

        vid.srcObject = new MediaStream(this.localStream);
        const played = vid.play();
        if (played && typeof played.catch === 'function') {
          played.catch(() => {});
        }
      }
    },
    watch: {
      isLocalStreamStarted(val) {
        if (val) {
          this.$nextTick(() => this.initPlayer());
        }
      }
    },
    mounted() {
      // Akış bu bileşen basılmadan önce hazır olmuş olabilir (izin daha erken
      // verildiyse watcher hiç tetiklenmez).
      if (this.isLocalStreamStarted) {
        this.$nextTick(() => this.initPlayer());
      }
    }
  }
</script>
